import { LINE_COLOR, LINE_WIDTH } from '@/constants/canvas';
import { Feature } from 'ol';
import { Geometry } from 'ol/geom';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import Fill from 'ol/style/Fill';
import Stroke from 'ol/style/Stroke';
import Style from 'ol/style/Style';
import { LAYER_TYPE } from '@/components/Map/MapViewer/MapViewer.constants';

/**
 * Wraps a reactions {@link VectorSource} in a fresh {@link VectorLayer} so each
 * map can render the shared source with its own layer object.
 */
export const createReactionsLayer = (
  source: VectorSource<Feature<Geometry>>,
): VectorLayer<VectorSource<Feature<Geometry>>> => {
  const vectorLayer = new VectorLayer({
    // eslint-disable-next-line no-magic-numbers
    zIndex: Infinity,
    source,
    style: new Style({
      fill: new Fill({ color: LINE_COLOR }),
      stroke: new Stroke({ color: LINE_COLOR, width: LINE_WIDTH }),
    }),
  });
  vectorLayer.set('type', LAYER_TYPE.REACTIONS_LAYER);
  return vectorLayer;
};
